/* unplugin-vue-components disabled */import { render } from "./ai-tabs.vue?vue&type=template&id=7f71e570&scoped=true"
import script from "./ai-tabs.vue?vue&type=script&lang=js"
export * from "./ai-tabs.vue?vue&type=script&lang=js"

import "./ai-tabs.vue?vue&type=style&index=0&id=7f71e570&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f71e570"],['__file',"src/components/ai-chat-v2/ai-tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f71e570"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f71e570', __exports__)) {
    api.reload('7f71e570', __exports__)
  }
  
  module.hot.accept("./ai-tabs.vue?vue&type=template&id=7f71e570&scoped=true", () => {
    api.rerender('7f71e570', render)
  })

}


export default __exports__